import Style from 'molo-shared/lib/models/Style';

export function normalizeColorCode(value: string | number | undefined | null): string {
    if (value === undefined || value === null) {
        return '';
    }

    return String(value).trim();
}

export function normalizeMasterColor(value: string | number | undefined | null): string {
    return normalizeColorCode(value);
}

export interface SameColorSearchQuery {
    masterColor?: string;
    color?: string;
    masterId?: string;
    colorCode?: string;
}

export function filterStylesBySameColor(styles: Style[], query: SameColorSearchQuery): Style[] {
    const masterColor = normalizeMasterColor(query.masterColor);
    if (masterColor) {
        return styles.filter(
            (style) => normalizeMasterColor(style.masterColor) === masterColor
        );
    }

    const legacyColor = normalizeColorCode(query.color || query.colorCode);
    if (!legacyColor) {
        return styles;
    }

    return styles.filter(
        (style) => normalizeColorCode(style.colorCode) === legacyColor
    );
}

export function ensureClickedStyleIncluded(
    result: Style[],
    clicked: { masterId?: string; colorCode?: string },
    fullCollection: Style[]
): Style[] {
    const masterId = normalizeColorCode(clicked.masterId);
    const colorCode = normalizeColorCode(clicked.colorCode);

    if (!masterId || !colorCode) {
        return result;
    }

    const alreadyIncluded = result.some(
        (style) =>
            normalizeColorCode(style.masterId) === masterId &&
            normalizeColorCode(style.colorCode) === colorCode
    );

    if (alreadyIncluded) {
        return result;
    }

    const clickedStyle = fullCollection.find(
        (style) =>
            normalizeColorCode(style.masterId) === masterId &&
            normalizeColorCode(style.colorCode) === colorCode
    );

    if (!clickedStyle) {
        return result;
    }

    return [clickedStyle, ...result];
}

export function backfillOrderType(styles: Style[], orderType: string): Style[] {
    const normalizedOrderType = orderType.trim();
    if (!normalizedOrderType) {
        return styles;
    }

    for (const style of styles) {
        if (!style.orderType || !String(style.orderType).trim()) {
            style.orderType = normalizedOrderType;
        }
    }

    return styles;
}

export function filterStylesByAllowedOrderTypes(
    styles: Style[],
    allowedTypes: string[],
    queryOrderType: string
): Style[] {
    const normalizedQueryOrderType = queryOrderType.trim();

    return styles.filter((style) => {
        const styleOrderType = style.orderType ? String(style.orderType).trim() : '';

        if (normalizedQueryOrderType && styleOrderType === normalizedQueryOrderType) {
            return true;
        }

        if (!styleOrderType && normalizedQueryOrderType) {
            return true;
        }

        return allowedTypes.indexOf(styleOrderType) !== -1;
    });
}
